import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AffiliatePortal = lazy(() => import("@/pages/AffiliatePortal"));

export const Route = createFileRoute("/affiliate-portal")({
  component: AffiliatePortal,
});
